<template>
    <div id="reportClassHour">
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection" @keyup.enter.native="getDate()">
                <Form-item prop="zoneId" label="校区" :label-width="60">
                    <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem prop="daterange" label="消耗课时时间范围" :label-width="120">
                    <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                style="width: 240px"
                                format="yyyy-MM-dd" @on-change="searchForm.daterange=$event"></DatePicker>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="getDate"  size="small" style="margin-right:10px;">搜索</Button>
                    <Button type="primary" @click="exportDate"  size="small">导出</Button>
                </FormItem>
            </Form>
            <Table :columns="columns" :data="data" :loading="tbloading"></Table>
        </card>
    </div>
</template>
<script>
  import moment from 'moment';
  import config from '@/config'
  const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

  export default {
    name: 'report_class_hour',
    data () {
      return {
        total:0,
        searchForm:{
          daterange: [
            moment(new Date()).startOf("month").format("YYYY-MM-DD"),
            moment(new Date()).endOf("month").format("YYYY-MM-DD")
          ],
          zoneId:this.$store.state.app.zoneList[0].id
        },
        tbloading:false,
        columns: [
          {
            title: '序号',
            type: 'index'
          },
          {
            title: '学员',
            key: 'studentName'
          },
          {
            title: '课程',
            key: 'courseName'
          },
          {
            title: '班级',
            key: 'className'
          },
          {
            title: '性别',
            key: 'sex'
          },
          {
            title: '联系方式',
            key: 'mobile'
          },
          {
            title: '老师',
            key: 'teacherName'
          },
          {
            title: '购买课时',
            key: 'class_num_buy'
          },
          {
            title: '报名费用',
            key: 'total_money'
          },
          {
            title: '消耗课时',
            key: 'num'
          },
          {
            title: '累计消耗课时',
            key: 'class_num_used'
          },
          {
            title: '时间段剩余课时',
            key: 'class_num_remain_history'
          },
          {
            title: '当前剩余课时',
            key: 'class_num_remain'
          },
        ],
        data: [],
      }
    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
    },
    methods: {
      getDate(){
        this.tbloading = true;
        this.$api.report.classhour({
          startDate:this.searchForm.daterange[0],
          endDate:this.searchForm.daterange[1],
          zoneId:this.searchForm.zoneId
        }).then(resp => {
          this.tbloading = false;
          this.data = resp.list;
        });
      },
      exportDate(){
        window.open(baseUrl+"edu/web/report/exportclasshour?startDate="
          +this.searchForm.daterange[0]+"&endDate="+this.searchForm.daterange[1]
          +"&zoneId="+this.searchForm.zoneId);
      }
    },
    mounted: function () {
      this.getDate();
    }
  }
</script>
